var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('transition',{attrs:{"name":"view","appear":"","enter-active-class":"animated fadeIn","leave-active-class":"animated slideOutDown"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }